import { render, staticRenderFns } from "./catalogueTreeMenus.vue?vue&type=template&id=7b6e11ba&scoped=true"
import script from "./catalogueTreeMenus.vue?vue&type=script&lang=js"
export * from "./catalogueTreeMenus.vue?vue&type=script&lang=js"
import style0 from "./catalogueTreeMenus.vue?vue&type=style&index=0&id=7b6e11ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e11ba",
  null
  
)

export default component.exports